<template>
  <div class="fixed-bottom" >
    <router-link to="/quiz-home" class="home">
      <img src="@/assets/img/footer-menu/home.png"
           :class="getRoute() === 'quiz-home' ? 'link-active' : ''"
           alt="dashboard">
    </router-link>
    <div class="footer-menu">
      <div class="left-menu">
        <div @click="showModal = true"
                     class="d-flex flex-column justify-content-center align-items-center footer-link-left"
                     :style="getRoute() !== 'leaderboard' ? {'color': '#BDBDBD'} : {'color': '#3EAAFF'}">
          <i class="fa fa-star"></i>
          <div class="footer-link-title">{{ $t('LEADERBOARD') }}</div>
        </div>
        <div @click="showModal = true"
                     class="d-flex flex-column justify-content-center align-items-center footer-link-left"
                     :style="getRoute() !== 'store' ? {'color': '#BDBDBD'} : {'color': '#3EAAFF'}">
          <i class="fa fa-store"></i>
          <div class="footer-link-title">{{ $t('STORE')}}</div>
        </div>
      </div>
      <div class="right-menu">
        <div @click="showModal = true"
                     class="d-flex flex-column justify-content-center align-items-center footer-link-right"
                     :style="getRoute() !== 'friends' ? {'color': '#BDBDBD'} : {'color': '#3EAAFF'}">
          <i class="fa fa-user-friends"></i>
          <div class="footer-link-title">{{ $t('FRIENDS')}}</div>

        </div>
        <div @click="showModal = true"
                     class="d-flex flex-column justify-content-center align-items-center footer-link-right"
                     :style="getRoute() !== 'notifications' ? {'color': '#BDBDBD'} : {'color': '#3EAAFF'}">
          <i class="fa fa-bell"></i>
          <div class="footer-link-title">{{ $t('NOTIFICATIONS') }}</div>
        </div>
      </div>


    </div>
  </div>
  <SubscriptionModal :modal-show="showModal" v-if="showModal"/>
</template>

<script>
import SubscriptionModal from "@/views/components/SubscriptionModal.vue";

export default {
  name: "DashboardFooterMenu",
  components: {SubscriptionModal},
  data() {
    return {
      showModal: false,
    }
  },
  created() {
    this.emitter.on('subscription-modal-close-event', (evt) => {
      this.showModal = evt.eventContent;
    });
  },
  methods: {
    getRoute() {
      const routeArr = this.$route.path.split("/");
      return routeArr[1];
    },
  }
}
</script>

<style scoped>

</style>
